import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

let cachedTexts: Record<string, string> | null = null;
let loadingPromise: Promise<Record<string, string>> | null = null;

async function loadTexts(): Promise<Record<string, string>> {
    if (cachedTexts) return cachedTexts;
    if (loadingPromise) return loadingPromise;

    loadingPromise = (async () => {
        const snapshot = await getDocs(collection(db, "appTexts"));
        const data: Record<string, string> = {};
        snapshot.forEach((doc) => {
            data[doc.id] = doc.data().value;
        });
        cachedTexts = data;
        loadingPromise = null;
        return data;
    })();

    return loadingPromise;
}

export function useTexts() {
    const [texts, setTexts] = useState<Record<string, string>>(cachedTexts || {});
    const [loading, setLoading] = useState<boolean>(!cachedTexts);

    useEffect(() => {
        if (cachedTexts) {
            setTexts(cachedTexts);
            setLoading(false);
            return;
        }
        loadTexts().then((data) => {
            setTexts(data);
            setLoading(false);
        });
    }, []);

    const getText = (key: string, fallback: string): string => {
        return texts[key] ?? fallback;
    };

    return { getText, texts, loading };
}